import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ClientAccount } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TData = Pick<ClientAccount, 'paymentMethod'>;

export const useBillingPaymentMethod = (
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query clientAccount {
      clientAccount {
        paymentMethod
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['billingPaymentMethod'],
    queryFn: async () =>
      client.request({
        data: {
          gql: graphql
        }
      })
  });
};
